<template>
  <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M 422.955 429.617 C 422.955 429.617 390.757 353.515 274.191 344.084 L 277.081 364.885 L 271.136 371.491 L 246.699 375.233 L 224.903 364.885 L 214.149 355.419 L 214.149 344.773 C 97.757 355.886 70.35 419.638 70.35 419.638 C 70.35 419.638 110.268 466.208 150.185 479.515 C 155.029 481.129 159.333 482.597 163.241 483.929 C 191.545 493.579 199.08 496.146 240 496.146 C 286.57 496.146 318.943 490.963 359.752 472.86 C 390.397 459.268 422.955 429.617 422.955 429.617 Z"
      fill="currentColor"
      style=""
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M 249.977 492.821 C 384.09 492.821 492.81 384.101 492.81 249.989 C 492.81 115.876 384.09 7.158 249.977 7.158 C 115.865 7.158 7.147 115.876 7.147 249.989 C 7.147 384.101 115.865 492.821 249.977 492.821 Z M 249.977 499.474 C 387.765 499.474 499.463 387.776 499.463 249.989 C 499.463 112.202 387.765 0.505 249.977 0.505 C 112.191 0.505 0.494 112.202 0.494 249.989 C 0.494 387.776 112.191 499.474 249.977 499.474 Z"
      fill="currentColor"
      style=""
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M 214.72 181.479 L 212.739 358.949 C 224.417 369.439 237.079 375.125 245.444 376.654 C 253.447 378.115 267.733 375.865 278.999 368.723 L 268.104 298.878 L 272.683 299.978 C 288.539 303.784 298.195 301.128 306.886 294.742 C 315.715 288.254 321.965 277.58 326.222 264.51 C 334.384 239.457 334.774 205.038 333.337 181.479 L 214.72 181.479 Z"
      fill="#F7BBBE"
      style=""
    />
    <path
      d="M 190.44 148.942 C 148.338 203.673 182.59 263.01 210.072 289.907 L 223.373 293.233 C 218.109 282.708 220.046 252.121 220.046 236.683 C 220.046 221.248 234.877 230.219 241.309 233.143 C 231.953 226.126 215.632 198.506 248.325 185.781 C 279.922 173.481 316.513 200.093 336.035 200.093 L 359.757 173.481 C 397.647 155.239 355.914 132.57 336.035 117.367 C 316.388 58.426 269.376 98.656 248.325 126.138 C 235.696 120.525 203.887 141.341 190.44 148.942 Z"
      fill="black"
      style=""
    />
  </svg>
</template>
